import { render, staticRenderFns } from "./ClienteAnticipo.vue?vue&type=template&id=5615a9da"
import script from "./ClienteAnticipo.vue?vue&type=script&lang=js"
export * from "./ClienteAnticipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports